import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-register',
    template: '',
    standalone: false
})
export class RegisterComponent implements OnInit {
    constructor(
        private readonly router: Router
    ) {}

    public ngOnInit(): void {
        const state = encodeURIComponent(this.router.routerState.snapshot.root.queryParams.redirect_uri);
        const clientId = 'pl.onetads.panel.konto.front.onetapi.pl';
        const redirectUri = encodeURIComponent('https://panel.onetads.pl/user-session-proxy/refresh');

        window.location.href = `https://konto.onet.pl/register?state=${state}&client_id=${clientId}&redirect_uri=${redirectUri}`;
    }
}
